<template>
    <div>
        <OnePageMain :design-time="false" :one-page-id="SystemId"></OnePageMain>

    </div>
</template>

<script>/**

 **/
import OnePageMain from "@/pages/featureOnePage/OnePageMain.vue";


export default {
    components: {OnePageMain},
    props: {
        value: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data: function () {
        return {
            SystemId: "",
        };
    },
    methods: {
        async loadData() {
            // let data=await apiUtil.api_SupplierTODO("12138114-01")

            // this.data=data
        },
    },
    mounted() {
        this.SystemId=this.$route.query.systemId
        // this.initValue()
        //this.loadData()
    },
}
</script>

<style scoped>

</style>
